/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { User } from '../_models/user.model';

const API_USERS_URL = 'api/users';

@Injectable()
export class AuthService {
  constructor(private http: HttpClient) {}

  // Authentication/Authorization
  login(email: string, password: string): Observable<any> {
    //return this.http.post<User>(API_USERS_URL, { email, password });
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    httpHeaders.append('skip', 'true');
    return this.http.post<any>(
      'api/api-token-auth/',
      { email, password },
      { headers: httpHeaders }
    ); //.pipe( catchError( () => { console.log('asdasd'); return of(null); } ) );
  }

  getUserByToken(): Observable<User> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    const httpHeaders = new HttpHeaders();
    //httpHeaders.set('Authorization', 'Bearer ' + userToken);
    //httpHeaders.set('Authorization', 'JWT '+userToken);
    //console.log(environment.authTokenKey);
    return this.http.post<User>(
      'api/auth/getluser/',
      {},
      { headers: httpHeaders }
    );
  }

  //_register(
  register(user: User): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User>('api/auth/users/', user, {
      headers: httpHeaders,
    });
    /*    .pipe(
				map((res: User) => {
					return res;
				}),
				catchError(err => {
					return null;
				})
			);*/
  }

  /*
   * Submit forgot password request
   *
   * @param {string} email
   * @returns {Observable<any>}
   */
  public requestPassword(email: string): Observable<any> {
    return this.http
      .get(API_USERS_URL + '/forgot?=' + email)
      .pipe(catchError(this.handleError('forgot-password', [])));
  }

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>('api/auth/users/');
  }

  getUserById(userId: number): Observable<User> {
    const url = `${'api/auth/users'}/${userId}/`;
    return this.http.get<User>(url);
  }

  public verifyToken(tk: any): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'application/json');
    httpHeaders.append('skip', 'true');
    return this.http.post(
      'api/api-token-verify/',
      { refresh: tk },
      { headers: httpHeaders }
    );
  }

  // DELETE => delete the user from the server
  deleteUser(userId: number) {
    const url = `${'api/auth/users'}/${userId}`;
    return this.http.delete(url);
  }

  // UPDATE => PUT: update the user on the server
  updateUser(_user: User): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    const url = `${'api/auth/users'}/${_user.id}/`;
    return this.http.put(url, _user, { headers: httpHeaders });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: User): Observable<User> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User>('api/auth/create_user/', user, {
      headers: httpHeaders,
    });
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(
      'api/auth/find_users/',
      queryParams,
      { headers: httpHeaders }
    );
  }

  filterUsers(queryParams: any): Observable<User[]> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User[]>('api/auth/filter_users/', queryParams, {
      headers: httpHeaders,
    });
  }

  /*findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
	const httpHeaders = new HttpHeaders();
	httpHeaders.set('Content-Type', 'application/json');
	return this.http.get<QueryResultsModel>('api/auth/users/', { headers: httpHeaders});
}*/

  /*
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
